import Session from "utils/user-storage";
import axios from "axios";
import { getApimSubscriptionKey, getAuthenticationProvider, getHost } from "./config-environment";
import { authProvider } from "../providers/authProvider";
import { tokenAuthorization } from "../providers/tokenProvider";

const instance = axios.create({
  timeout: 1000000000000,
});

const getLanguage = (languageCode) => {
  let language;

  switch (languageCode) {
    case 1:
      language = "pt-BR"
      break;
    case 3:
    case 5:
      language = "es-ES";
      break;
    case 7:
      language = "en-GB";
      break;
    case 8:
      language = "es-MX";
      break;
    case 2:
    default:
      language = "en-US";
      break;
  }

  return language;
}

instance.interceptors.request.use(
  async (config) => {
    // Set baseURL at request time to ensure config is loaded
    const host = getHost();
    if (!host) {
      console.error('Host URL is not available. Config may not be loaded yet.');
    }
    config.baseURL = host;

    try {

      const provider = getAuthenticationProvider()
      let token = ''

      if (provider === 'B2C') {
        token = await authProvider().getAccessToken()
      } else {
        const key = Object.keys(sessionStorage).find(key => key.includes("oidc"))
        token = JSON.parse(sessionStorage.getItem(key))?.access_token
      }

      config.headers.Authorization = `Bearer ${provider === 'B2C' ? token.accessToken: token}`;
      config.headers['Ocp-Apim-Subscription-Key'] = getApimSubscriptionKey();
    } catch (err) {
      console.log("Error token: ", err);
    }

    const isUrlAuthenticationEmail =
      config.url === "usuario/emailAuthentication/";
    const isUrlGetTokenAuthorization =
      config.url === "/users:validation-token";

    config.headers["Accept-Language"] = Session.get() && getLanguage(Session.get().Idioma);
    config.headers["Accept"] = "application/json";

    if (!(isUrlAuthenticationEmail || isUrlGetTokenAuthorization) && getAuthenticationProvider() === 'B2C') {      
      config.headers["ValidationToken"] = await tokenAuthorization();
    }

    return config;
  },
   (error) => {
    if (error instanceof Error) {
      return Promise.reject(error);
    }
    return Promise.reject(new Error(String(error)));
  }
);

function Fetch() {
  return {
    get: (url) => instance.get(url),
    post: (url, data) => instance.post(url, data),
    put: (url, data) => instance.put(url, data),
    delete: (url, data) => instance.delete(url, { data }),
    patch: (url, data) => instance.patch(url, data)
  };
}

export default Fetch();
